import React, { useState, useContext } from 'react';
import { ThemeContext } from '../theme';
import InputField from '../components/InputField';
import SelectField from '../components/SelectField';
import ToggleSwitch from '../components/ToggleSwitch';
import Button from '../components/Button';

const ILLUS_URL = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961697/onboarding_image_3_lqfmsl.webp';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

export default function PreferencesScreen({ onSkip, onNext }) {
  const theme = useContext(ThemeContext);
  const [language,      setLanguage]      = useState('English');
  const [identity,      setIdentity]      = useState('Irish');
  const [saveHistory,   setSaveHistory]   = useState(true);
  const [notifications, setNotifications] = useState(false);

  const LANGUAGES  = ['English', 'Spanish', 'French', 'German', 'Portuguese'];
  const IDENTITIES = ['Irish', 'British', 'American', 'Australian', 'Indian'];

  return (
    <div style={{ flex: 1, alignSelf: 'stretch', display: 'flex', backgroundColor: theme.bgPrimary }}>
      <style>{`
        @keyframes onboardImgScaleOut {
          from { transform: scale(1.2); }
          to   { transform: scale(1); }
        }
      `}</style>

      {/* Left panel — illustration */}
      <div style={{ width: '38%', flexShrink: 0, position: 'relative', overflow: 'hidden', backgroundColor: theme.cardBg100 }}>
        <img
          src={ILLUS_URL}
          alt=""
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', animation: 'onboardImgScaleOut 0.6s ease-out both' }}
        />
      </div>

      {/* Right panel — same padding as SignupScreen */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 104px',
          overflowY: 'auto',
          backgroundColor: theme.cardBg,
        }}
      >
        {/* Outer column: gap 80×0.75=60px between header+fields and buttons */}
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: s(80) }}>

          {/* Top section: header + fields */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: s(48) }}>

            {/* Header: title + step */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: s(8) }}>
              <h1
                className="font-bogart"
                style={{ fontSize: s(36), fontWeight: 700, lineHeight: `${s(44)}px`, color: theme.text100, margin: 0 }}
              >
                Select your preferences
              </h1>
              <p
                className="font-satoshi"
                style={{ margin: 0, fontSize: s(18), lineHeight: `${s(24)}px`, color: theme.btnPrimaryBg }}
              >
                Step 1/2
              </p>
            </div>

            {/* Fields + toggles */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: s(40) }}>

              {/* Dropdown fields: gap 16×0.75=12px */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: s(16) }}>
                <SelectField
                  label="Language"
                  options={LANGUAGES}
                  value={language}
                  onChange={setLanguage}
                  scale={SCALE}
                />
                <SelectField
                  label="Cultural Identity"
                  options={IDENTITIES}
                  value={identity}
                  onChange={setIdentity}
                  scale={SCALE}
                />
              </div>

              {/* Divider + toggles */}
              <div
                style={{
                  borderTop: `1px solid ${theme.border}`,
                  paddingTop: s(24),
                  display: 'flex',
                  flexDirection: 'column',
                  gap: s(16),
                }}
              >
                {/* Save History row */}
                <div style={{ display: 'flex', alignItems: 'center', gap: s(16) }}>
                  <span
                    className="font-satoshi"
                    style={{ flex: 1, fontSize: s(20), lineHeight: `${s(32)}px`, fontWeight: 500, color: theme.text100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                  >
                    Save History
                  </span>
                  <ToggleSwitch checked={saveHistory} onChange={setSaveHistory} scale={SCALE} />
                </div>

                {/* Notifications row */}
                <div style={{ display: 'flex', alignItems: 'center', gap: s(16) }}>
                  <span
                    className="font-satoshi"
                    style={{ flex: 1, fontSize: s(20), lineHeight: `${s(32)}px`, fontWeight: 500, color: theme.text100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                  >
                    Notifications
                  </span>
                  <ToggleSwitch checked={notifications} onChange={setNotifications} scale={SCALE} />
                </div>
              </div>

            </div>
          </div>

          {/* Buttons row: Skip + Next, gap 20×0.75=15px */}
          <div style={{ display: 'flex', gap: s(20) }}>
            <Button
              variant="tertiary"
              onClick={onSkip}
              scale={SCALE}
              style={{ flex: 1 }}
            >
              Skip
            </Button>
            <button
              onClick={onNext}
              className="font-satoshi font-bold"
              style={{
                flex: 1,
                padding: `${s(20)}px`,
                borderRadius: s(20),
                border: 'none',
                backgroundColor: theme.btnPrimaryBg,
                color: theme.btnPrimaryText,
                fontSize: s(18),
                lineHeight: `${s(24)}px`,
                cursor: 'pointer',
                transition: 'background-color 0.15s',
              }}
            >
              Next
            </button>
          </div>

        </div>
      </div>

    </div>
  );
}
